// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  width: 100%;
  min-height: 100vh;
}

.login-content-container {
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-content-container h1 {
  color: #f4f6ff;
  font-weight: 700;
  font-size: 3rem;
  text-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.login-content-container h1 span {
  font-weight: 300;
}

.box-container {
  background-color: #f4f6ff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  padding: 3rem 3rem 4rem 3rem;
}

.box-container h4 span {
  color: #3379be;
  font-weight: 600;
}

.box-container .input-group-text {
  border-radius: 0;
}

.box-container form input {
  border-radius: 0;
  outline: none;
}

.box-container form .form-label {
  width: 350px;
}

.box-container form button {
  width: 100%;
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf;;uEAEqE;AACvE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB;;uEAEqE;EACrE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".login-container {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n}\r\n\r\n.login-content-container {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.login-content-container h1 {\r\n  color: #f4f6ff;\r\n  font-weight: 700;\r\n  font-size: 3rem;\r\n  text-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\r\n    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\r\n    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n}\r\n\r\n.login-content-container h1 span {\r\n  font-weight: 300;\r\n}\r\n\r\n.box-container {\r\n  background-color: #f4f6ff;\r\n  border-radius: 10px;\r\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\r\n    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\r\n    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n  padding: 3rem 3rem 4rem 3rem;\r\n}\r\n\r\n.box-container h4 span {\r\n  color: #3379be;\r\n  font-weight: 600;\r\n}\r\n\r\n.box-container .input-group-text {\r\n  border-radius: 0;\r\n}\r\n\r\n.box-container form input {\r\n  border-radius: 0;\r\n  outline: none;\r\n}\r\n\r\n.box-container form .form-label {\r\n  width: 350px;\r\n}\r\n\r\n.box-container form button {\r\n  width: 100%;\r\n  border-radius: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
